<template>
  <div class="footer">
    <div class="item">
      <i>Sales</i><br>
      emma@photoai.tech
    </div>
    <div class="item">
      <i>Customer Support</i><br>
      support@photoai.tech
    </div>
    <div class="item">
      <i>Other</i><br>
      derek@photoai.tech
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterComp',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer {
    width: 100%;
    padding: 20px;
    margin-top: 0px;
    box-sizing: border-box;
    border-top: 1px solid #f1f1f1;
    text-align: center;
    background-color: #f1f1f1;
  }
  i {
    color: grey;
    font-size: 12px;
  }
  .item {
    display: inline-block;
    text-align: left;
    margin: 20px;

  }
  .small {
    font-size: 14px;
    font-weight: normal;
    line-height: 16px;
    display: inline-block;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterComp.vue